<template>
  <div class="loading-page">
    <AntResult
      :title="getTitle"
      :sub-title="getSubTitle"
      :loading="getStatus === EAntResultStatus.INFO"
      :status="getStatus !== EAntResultStatus.INFO ? getStatus : undefined"
    >
      <template #icon v-if="getStatus === EAntResultStatus.INFO">
        <AntIcon :url="EAntIconUrl.LOADING_OUTLINED" />
      </template>
    </AntResult>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';

import {EAntIconUrl} from '@/assets/ant/icon/enums';
import {EAntResultStatus} from '@/assets/ant/result/enums';

import {keycloakAPI} from '@/assets/keycloak';

import AntIcon from '@/assets/ant/icon/AntIcon.vue';
import AntResult from '@/assets/ant/result/AntResult.vue';

const getStatus = computed(() => {
  return !keycloakAPI.getIsInit.value
    ? EAntResultStatus.INFO
    : keycloakAPI.getIsInitError.value
      ? EAntResultStatus.ERROR
      : EAntResultStatus.SUCCESS;
});

const getTitle = computed(() => {
  switch (getStatus.value) {
    case EAntResultStatus.INFO:
      return 'Загрузка';
    case EAntResultStatus.ERROR:
      return 'Нужно немного подождать';
    case EAntResultStatus.SUCCESS:
      return 'Успешно';
    default:
      return '';
  }
});

const getSubTitle = computed(() => {
  switch (getStatus.value) {
    case EAntResultStatus.INFO:
      return 'Нужно немного подождать';
    case EAntResultStatus.ERROR:
      return 'Обратитесь к администратору для решения проблемы';
    case EAntResultStatus.SUCCESS:
      return 'Скоро произойдет переход на страницу';
    default:
      return '';
  }
});
</script>

<style lang="scss">
.loading-page {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
